/**
 * Share helpers — Phase A · Feature 4.
 *
 * Direct unit links use the iframe-safe query-param form:
 *     /p/<slug>?unit=<code>&lang=<ar|tr|ru>
 *
 * Same shape is used by the QR code in the PDF footer so a printed
 * brochure → scan → buyer's phone → exact unit page all chain together.
 */

export function buildUnitUrl(slug, code, lang) {
  if (!slug || !code) return null;
  const params = new URLSearchParams();
  params.set("unit", code);
  params.set("lang", lang || "en");
  return `${window.location.origin}/p/${slug}?${params.toString()}`;
}

export function buildShortlistUrl(slug, codes, lang) {
  if (!slug || !codes?.length) return null;
  const params = new URLSearchParams();
  params.set("shortlist", codes.join(","));
  params.set("lang", lang || "en");
  return `${window.location.origin}/p/${slug}?${params.toString()}`;
}

export function buildPdfUrl(apiBase, slug, code, lang, planId) {
  const params = new URLSearchParams({ lang: lang || "en" });
  if (planId) params.set("plan_id", planId);
  return `${apiBase}/api/public/projects/${slug}/units/${encodeURIComponent(code)}/pdf?${params.toString()}`;
}

/** WhatsApp deep link with a humane prefilled message. */
export function whatsappShareLink(unitLabel, url) {
  const text = `${unitLabel}\n${url}`;
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Fallback for older / restricted browsers.
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      const copied = document.execCommand("copy");
      document.body.removeChild(ta);
      return copied;
    } catch {
      return false;
    }
  }
}
